import { Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import React, { useContext, useMemo } from 'react'
import { ThemeContext } from "../../context/ThemeContext";
import { TableVirtuoso } from 'react-virtuoso'
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CircleIcon from '@mui/icons-material/Circle';
import { useSymbolPrices } from '../../context/WebSocketContext';
import { useSelector } from 'react-redux';
import { getCookies } from '../../services/Cookies';

const WatchlistTable = ({ columns = [], data = [], loading, handleRowClick, onRowDoubleClick, cellStyleMapper = {}, onRowRightClick, activeRowId, onHeaderClick, watchlistHeight = 100 }) => {
    // const symbols = useSymbolPrices();
    const { darkMode } = useContext(ThemeContext);
    const { symbols } = useSelector(state => state?.watchlist)
    const id = getCookies("clientId");
    const storedHiddenSymbols = JSON.parse(localStorage.getItem(`hiddenSymbols_${id}`)) || [];
    const filteredSymbols = useMemo(() => {
        return Object.values(symbols).filter(symbol =>
            symbol.isVisible &&
            !storedHiddenSymbols.includes(symbol.id)
        );
    }, [symbols, data, storedHiddenSymbols]);

    const VirtuosoTableComponents = {
        Table: (props) => (
            <Table {...props} sx={{ borderCollapse: 'separate', tableLayout: 'fixed' }} />
        ),
        TableHead: React.forwardRef((props, ref) => <TableHead {...props} ref={ref} />),
        TableRow,
        TableBody: React.forwardRef((props, ref) => <TableBody {...props} ref={ref} />),
    };

    const fixedHeaderContent = () => (<TableRow >
        {columns.map((col, index) => (
            <TableCell onContextMenu={onHeaderClick} key={index} style={{ width: col?.width }} sx={{ fontWeight: "bold", p: 1, backgroundColor: darkMode ? "var(--background-color)" : 'var(--white)' ,whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis'}}>
                {col.title}
            </TableCell>
        ))}
    </TableRow>)
    const Row = useMemo(() => (index, row) => {
        return (
            <React.Fragment >
                {columns.map((col, colIndex) => {
                    const alignStyle = {};
                    return ( 
                        <TableCell sx={{border:'none',fontSize: "0.875rem", ...alignStyle,}}
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleRowClick && handleRowClick(row); }}
                            onDoubleClick={() => { onRowDoubleClick && onRowDoubleClick(row); }}
                            onContextMenu={(e) => { e.preventDefault(); e.stopPropagation(); onRowRightClick && onRowRightClick(e, row); }}
                            key={colIndex} style={{ padding: '10px' }}>
                            {
                                col?.render ? col.render(row?.[col?.dataIndex] || "", row, index) : row?.[col.dataIndex] || ""
                            }
                        </TableCell>
                    );
                })}
            </React.Fragment>
            // </TableRow>
        );
    }, [columns]);
    return (
        <Paper style={{ height: `calc(100% - 48px)`, width: '100%', }}>
            <TableVirtuoso
                data={filteredSymbols}
                components={VirtuosoTableComponents}
                fixedHeaderContent={fixedHeaderContent}
                itemContent={Row}
                height={20}
                style={{ backgroundColor: darkMode ? "#151924" : "#fff", }}
            >
            </TableVirtuoso>
        </Paper>
    )
}

export default WatchlistTable